import { ReactNode } from 'react';
import { BusinessSidebar } from '../sidebar/BusinessSidebar';
import { BusinessHeader } from '../header/BusinessHeader';
import { BusinessBottomNav } from '../nav/BusinessBottomNav';
import { BusinessSetupProvider } from '@/contexts/BusinessSetupContext';

export interface BusinessLayoutProps {
  children: ReactNode;
}

const BusinessLayout = ({ children }: BusinessLayoutProps) => {
  return (
    <BusinessSetupProvider>
      <div className="min-h-screen bg-[#F0F4F0]">
        <BusinessHeader />
        {/* Sidebar: desktop only */}
        <BusinessSidebar />
        <main className="sm:pl-64 pt-16 min-h-screen pb-20 sm:pb-0">
          <div className="p-4 sm:p-8">
            {children}
          </div>
        </main>
        {/* Bottom nav: mobile only */}
        <BusinessBottomNav />
      </div>
    </BusinessSetupProvider>
  );
}

export { BusinessLayout }; 